import { isAuth } from "../../helpers/cookies";
export const JOB_URL = 'job';
export const COMPANY_URL = 'company';
export const GET_JOB_MESSAGES_URL = `company/${isAuth().company_id}/job/`
export const GET_JOB_LIST = `listings`
export const SEND_PROOF = `send`
export const PROOF_LOG_TABLE = `prooflog`
export const VIEW_PROOF = `viewproof`
export const PROOF_APPROVE = `proof-approve`
export const PROOF_REJECT = `proof-reject`
export const ADD_BRAND = 'add'
export const GET_BRAND_LIST = `job/list`
export const REMOVE_BRAND = `job/brand-library`
export const REMOVE_BRAND_ITEM = `job/brand-library/item`
export const SIDEBAR_MENU_URL = `sidebar-menu`
export const FOLDER_URL = 'folders'
export const DOWNLOAD_CORRECTIONS_REPORT_URL = 'reports/corrections/download'
export const DOWNLOAD_COMPLETED_REPORT_URL = 'reports/completed/download'
